import * as Actions from "../Actions/TarefaApontamentoActions";

const initialState = {
    data: null,
    operacoes: null,
    error: null,
    warning: null,
    info: null,
    dialog: null,
    novoDialog: null,
    reciboDialog: null,
    recibos: null,
    pedidos: null,
};

const TarefaApontamentoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_TAREFAAPONTAMENTOS:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.GET_PEDIDOS_EM_ABERTO:
            {
                return {
                    ...state,
                    pedidos: action.payload,
                };
            }
        case Actions.GET_TAREFAAPONTAMENTO:
            {
                return {
                    ...state,
                    novoDialog: action.payload
                };
            }
        case Actions.TOGGLE_IMPRIMIR_RECIBO:
            {
                return {
                    ...state,
                    reciboDialog: action.id,
                    recibos: null
                };
            }
        case Actions.GET_RECIBOS:
            {
                return {
                    ...state,
                    recibos: action.payload
                };
            }
        case Actions.GET_TAREFAAPONTAMENTOS_OPERACAO:
            {
                return {
                    ...state,
                    operacoes: action.payload,
                };
            }
        case Actions.TAREFAAPONTAMENTO_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    error: action.payload
                };
            }
        case Actions.TAREFAAPONTAMENTO_INFO:
            {
                return {
                    ...state,
                    success: true,
                    info: action.payload,
                    id: action.id
                };
            }
        case Actions.TAREFAAPONTAMENTO_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    warning: action.payload
                };
            }
        case Actions.OPEN_TAREFAAPONTAMENTODIALOG:
            {
                return {
                    ...state,
                    dialog: action.payload
                };
            }
        case Actions.OPEN_NOVO_TAREFAAPONTAMENTODIALOG:
            {
                return {
                    ...state,
                    novoDialog: action.payload
                };
            }
        case Actions.NOVAGUIA_TAREFAAPONTAMENTO:
            {
                return {
                    ...state,
                    novoDialog: {
                        ...action.payload,
                        natureza: action.payload.natureza + 1,
                        idtarefaprocessoapontamento: null,
                        idparent: action.payload.idtarefaprocessoapontamento
                    }
                };
            }
        case Actions.GET_PEDIDO_ITENS:
            {
                return {
                    ...state,
                    pedidos: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default TarefaApontamentoReducer;
